import { render, staticRenderFns } from "./Sponsors.vue?vue&type=template&id=8f8f03d4&"
import script from "./Sponsors.vue?vue&type=script&lang=js&"
export * from "./Sponsors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports